import type { SVGProps } from 'react';
const SvgTextFormat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#text_format_svg__a)">
      <path
        fill="currentColor"
        d="M5 17v2h14v-2H5Zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2ZM12 5.98 13.87 11h-3.74L12 5.98Z"
      />
    </g>
    <defs>
      <clipPath id="text_format_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTextFormat;
